export const NONE = 'NONE';
export const PORTAL_TZ_ALIGNED = 'PORTAL_TZ_ALIGNED';
export const UTC_TZ_ALIGNED = 'UTC_TZ_ALIGNED';